<template>
  <div class="case-container pc-wrap">
    <!-- 盒子1 -->
    <div class="wrapper-box wrapper-box-1">
      <img class="box-bg" :src="caseTopBg1" alt="" />

      <div class="describe-box is-wrapper-box">
        <div class="row row-1 fontBold">云效科技-软件开发服务商</div>

        <div class="row row-2 fontBold">多行业 众品牌 海量案例</div>

        <div class="row-3">
          <div class="btn-wrap">
            <div class="btn" @click="jumpFormScrollTop">
              <button class="fontRegular">联系我们</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 盒子2 -->
    <div class="wrapper-box wrapper-box-2">
      <div class="wrapper-content is-wrapper-box">
        <div class="wrapp-title">
          <h2 class="fontBold">经典案例</h2>
          <div class="eng-explain fontRegular">CLASSIC CASE</div>
          <div class="sub-title fontRegular">
            真实项目案例，从细节里透露行业精益求精的专业，每一个高水准的创意，呈现出云效科技开发团队的智慧和力量
          </div>
        </div>

        <div class="wrapp-group-box">
          <list-card
            :src="item.icon"
            :name="item.name"
            :backgroundColor="item.backgroundColor"
            :routeQuery="item.routeQuery"
            v-for="(item, index) in wrappBox2__list1"
            :key="'box-3__item-1' + index"
            :keyIndex="index"
            :showFreeTrialTag="item.showFreeTrialTag"
            :isRichHtml="item.isRichHtml"
            class="addPadding"
          ></list-card>
        </div>
      </div>
    </div>

    <!-- 盒子7 -->
    <div class="wrapper-box wrapper-box-3">
      <img class="box-bg" :src="homeTopBg3" alt="" />

      <div class="wrapper-content is-wrapper-box">
        <div class="wrapp-group-box">
          <!-- 表单 -->
          <contact-form></contact-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, getCurrentInstance } from "vue";
import datajs from "../data.js";
import anime from "animejs";

const { proxy } = getCurrentInstance();

// 图片
// 首页顶部背景
const caseTopBg1 = require("@/assets/images/case-top-bg-1.png");
// 首页底部表单背景
const homeTopBg3 = require("@/assets/images/home-top-bg-3.png");

// 辅助参数
const { wrappBox2__list1 } = datajs.apply(proxy);

const { mainStore, dataStore } = proxy.$usePiniaModule();

//  定位底部表单
const jumpFormScrollTop = () => {
  const call = () => {
    const scrollTop =
      document.getElementsByClassName("footer-container")[0].offsetTop;
    window.scrollTo({ top: scrollTop });
  };

  // 操作鼠标
  dataStore.setGlobalClickRecord(function () {
    document
      .getElementsByClassName("wrapper-box-1")[0]
      .getElementsByClassName("btn")[0]
      .click();
  });
  call();
};

// 设置一些动画
const setPageSomeAnimation = () => {
  anime
    .timeline({
      direction: "reverse",
      easing: "easeInOutSine",
    })
    .add({
      duration: 300,
      targets: ".wrapper-box-1 .describe-box .row-3",
      translateX: 140,
      opacity: 0,
    })
    .add({
      duration: 300,
      targets: ".wrapper-box-1 .describe-box .row-2",
      translateX: -140,
      opacity: 0,
    })
    .add({
      duration: 300,
      targets: ".wrapper-box-1 .describe-box .row-1",
      translateX: 140,
      opacity: 0,
    });
};

onMounted(() => {
  setPageSomeAnimation();
});
</script>

<style lang="scss">
.case-container {
  &.pc-wrap {
    .is-wrapper-box {
      // width: calc(100vw - 720px);
      width: 100%;
      max-width: 1200px;
    }

    .wrapper-box {
      .wrapp-title {
        text-align: center;
        h2 {
          font-size: 34px;
          color: rgba(51, 51, 51, 1);
        }
        .eng-explain {
          color: #999999;
          font-size: 16px;
          margin: 7px 0;
        }
        .sub-title {
          font-size: 18px;
          color: #333333;
          line-height: 50px;
        }
      }

      .wrapper-content {
        .list-more {
          margin-top: 80px;
          text-align: center;
          img {
            margin: auto;
            width: 160px;
            height: 48px;
          }
        }
      }

      // 盒子1
      &-1 {
        // background-image: url(../../../assets/images/case-top-bg-1.png);
        // background-repeat: no-repeat;
        // background-attachment: fixed;
        // background-position: center 70px;
        // background-size: auto 720px;
        width: 100%;
        height: 100%;
        max-height: 5000px;
        position: relative;

        .box-bg {
          width: 100%;
          position: absolute;
          z-index: -1;
          height: 100%;
          object-fit: cover;
          top: 0;
          left: 0;
        }

        .describe-box {
          margin: 0 auto;
          padding-top: 237px;
          padding-bottom: 206px;
          position: relative;
          .row {
            text-align: center;
            color: rgba(51, 51, 51, 1);
            &-1 {
              font-size: 32px;
              margin-bottom: 17px;
            }
            &-2 {
              font-size: 80px;
              font-weight: bold;
              margin-bottom: 25px;
            }

            &-3 {
              .btn-wrap {
                margin-top: 50px;
                .btn {
                  display: flex;
                  justify-content: center;

                  button {
                    width: 160px;
                    height: 48px;
                    background: #0a41ff;
                    border: none;
                    color: #fff;
                    font-size: 16px;
                    border-radius: 2px;

                    &:active {
                      background-color: #0a41ffcf;
                    }
                  }
                }
              }
            }
          }
        }
      }

      // 盒子2
      &-2 {
        .wrapper-content {
          margin: 70px auto;
          .wrapp-group-box {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(2, auto);
            .group-item {
              padding: 37px;
              .item {
                font-size: 14px;
                .image {
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
                .title {
                  min-width: 30px;
                  width: 30px;
                  height: 30px;
                  border-radius: 30px;
                  color: transparent;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0 auto;
                  margin-top: 30px;
                  transition: width 600ms, color 200ms;
                }

                &:hover {
                  .title {
                    width: 130px;
                    color: white;
                    transition: width 200ms, color 600ms;
                    border-radius: 20px;
                  }
                }
              }
            }
          }
        }
      }

      &-3 {
        // background-image: url(../../../assets/images/home-top-bg-3.png);
        // background-repeat: no-repeat;
        // background-position: center 0;
        // background-size: auto 584px;
        // padding: 1px 0;
        width: 100%;
        height: 100%;
        max-height: 5000px;
        position: relative;

        .box-bg {
          width: 100%;
          position: absolute;
          z-index: -1;
          height: 100%;
          object-fit: cover;
          top: 0;
          left: 0;
        }

        .wrapper-content {
          padding: 60px 0;
          margin: auto;

          .sub-title {
            color: white;
            font-size: 30px;
            margin-bottom: 30px;
          }

          .wrapp-group-box {
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
